import {
  employeeSignCompleteApi,
  employerSignCompleteApi
} from '@/api/docusign';
import { DOCUSIGN_ROLE_TYPES } from '@/utils/constants';

/**
 * Complete the employee signing
 *
 * @param commit Vuex commit function
 * @param dispatch Vuex dispatch function
 * @param role The role of the user that has signed the document {@see DOCUSIGN_ROLE_TYPES}
 * @param applicationId The ID of the application that had the document signed
 * @param documentId The ID of the document that was signed
 *
 * @returns {Promise<*>}
 */
export function completeDocusign(
  { commit, dispatch },
  { role, applicationId, documentId }
) {
  return new Promise(async (resolve, reject) => {
    try {
      const payload = { applicationId, documentId };
      role === DOCUSIGN_ROLE_TYPES.employee
        ? await employeeSignCompleteApi(payload)
        : await employerSignCompleteApi(payload);
      commit('setState', ['loadingSignComplete', false]);
      return resolve();
    } catch (err) {
      commit('setState', ['loadingSignComplete', false]);
      return reject();
    }
  });
}
